import { useState } from "react";
import { CaretDown, CaretUp, MegaphoneSimple } from "@phosphor-icons/react";
import { fileUrl } from "../../lib/api";
import { useLang } from "../../i18n";
import Chapter from "./Chapter";
import Reveal from "./Reveal";

function AnnouncementBody({ a, i }) {
    return (
        <div className="mt-4">
            <p className="text-sm md:text-base font-light text-racing-muted leading-relaxed whitespace-pre-line" data-testid={`pengumuman-body-${i}`}>
                {a.body}
            </p>
            {a.image_url ? (
                <img
                    src={fileUrl(a.image_url)}
                    alt={a.title}
                    className="mt-6 w-full h-auto"
                    data-testid={`pengumuman-image-${i}`}
                />
            ) : null}
        </div>
    );
}

export default function Pengumuman({ announcements }) {
    const { t } = useLang();
    const [expanded, setExpanded] = useState({});

    const toggle = (id) => setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));

    return (
        <section id="pengumuman" className="py-24 md:py-32 border-t border-racing-line bg-[#FBF9F5]" data-testid="pengumuman-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="00" title={t.pengumuman_t} subtitle={t.pengumuman_s} />

                {announcements.length === 0 ? (
                    <p className="text-racing-muted" data-testid="pengumuman-empty">{t.pengumuman_empty}</p>
                ) : (
                    <div className="space-y-px border border-racing-line bg-racing-line">
                        {announcements.map((a, i) => (
                            <Reveal key={a.id} delay={i * 0.06}>
                                <article data-testid={`pengumuman-card-${i}`} className="bg-white p-8 md:p-10">
                                    <div className="border-l-4 border-[#FFB800] pl-6">
                                        <p className="text-[10px] uppercase tracking-[0.25em] text-racing-muted flex items-center gap-2">
                                            <MegaphoneSimple size={16} weight="duotone" className="text-racing-red" />
                                            {a.date}
                                        </p>
                                        <div className="flex flex-wrap items-start justify-between gap-4">
                                            <h3 className="mt-3 font-display uppercase text-2xl md:text-3xl text-neutral-900 leading-tight flex-1 min-w-[200px]" data-testid={`pengumuman-title-${i}`}>
                                                {a.title}
                                            </h3>
                                            {i > 0 && (
                                                <button
                                                    type="button"
                                                    onClick={() => toggle(a.id)}
                                                    data-testid={`pengumuman-toggle-${i}`}
                                                    className="mt-3 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] border border-racing-red text-racing-red hover:bg-racing-red hover:text-white px-4 py-2.5 transition-colors duration-300"
                                                >
                                                    {expanded[a.id] ? (
                                                        <>{t.pengumuman_less} <CaretUp size={14} weight="bold" /></>
                                                    ) : (
                                                        <>{t.pengumuman_more} <CaretDown size={14} weight="bold" /></>
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                        {(i === 0 || expanded[a.id]) && <AnnouncementBody a={a} i={i} />}
                                    </div>
                                </article>
                            </Reveal>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
